var React = require('react');

function ArrowGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.58 8.13H.32V5.87h7.26L9.27 6l-1-.9-3.6-3.59v-.14h3.06l5.95 5.52v.22l-5.95 5.52H4.67v-.14l3.65-3.55 1-.88z","fill":"#47e83a"}));
}

ArrowGreen.defaultProps = {"id":"Layer_1","viewBox":"0 0 14 14"};

module.exports = ArrowGreen;

ArrowGreen.default = ArrowGreen;
